import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
export default function CreatorDashboardSection() {
  const [creators, setCreators] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCreators();
  }, []);

  const fetchCreators = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/curator/all`
      );
      const data = await res.json();
      setCreators(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setCreators([]);
    }
  };

  if (creators.length === 0) return null; // Wait for data to render gracefully

  return (
    <section className="w-full py-16 md:py-20 bg-[#f7f6f1] relative font-sans">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* HEADER */}
       <div className="text-center mb-10 sm:mb-12 md:mb-16 space-y-3 sm:space-y-4 px-2">

  {/* HEADING */}
<h2 className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 
               text-[26px] sm:text-3xl md:text-4xl lg:text-5xl 
               font-serif font-bold text-[#1f2d1f] tracking-tight leading-tight">

  Trips planned by real travelers

  <span className="text-[9px] sm:text-[10px] md:text-xs font-bold tracking-widest uppercase 
                   px-2 py-0.5 sm:px-2.5 sm:py-1 
                   rounded-full bg-[#5b6f00]/10 text-[#5b6f00] 
                   border border-[#5b6f00]/20 whitespace-nowrap">
    Beta
  </span>
</h2>

  {/* SUBTEXT */}
 <p className="text-[13px] sm:text-base md:text-lg lg:text-xl 
              text-gray-500 max-w-xl md:max-w-2xl mx-auto 
              leading-relaxed px-2 sm:px-0">
  No guesswork. Just proven itineraries you can trust.
</p>

 

</div>

        {/* GRID CONTAINER */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-5 md:gap-6">
          {creators.map((creator, i) => (
            <div
              key={creator._id || i}
              onClick={() => navigate(`/creator/${creator.userId}`)}
              className="bg-white rounded-[20px] p-3 sm:p-4 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_12px_30px_rgb(91,111,0,0.08)] hover:-translate-y-1.5 transition-all duration-300 cursor-pointer flex flex-col group border border-gray-100"
            >
              {/* IMAGE WRAPPER */}
              <div className="relative w-full aspect-[1/1] sm:aspect-square rounded-[16px] overflow-hidden bg-gray-100 mb-4">
                {creator.avatar ? (
                  <img
                    src={creator.avatar}
                    alt={creator.fullName}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                    draggable="false"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-4xl font-serif text-[#1f2d1f]/20 bg-[#f7f6f1]">
                    {creator.fullName?.[0]}
                  </div>
                )}
                
                {/* TOP BADGE */}
                {i < 3 && (
                  <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm shadow-sm text-[#1f2d1f] text-[10px] font-bold tracking-wide px-2.5 py-1 rounded-full flex items-center gap-1">
                    <span className="text-[#5b6f00]">★</span> Top Creator
                  </div>
                )}
              </div>

              {/* CARD CONTENT */}
              <div className="flex flex-col flex-1 px-1">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-serif text-[15px] sm:text-lg font-bold text-[#1f2d1f] line-clamp-1 group-hover:text-[#5b6f00] transition-colors">
                    {creator.fullName}
                  </h3>
                  <svg className="w-4 h-4 text-[#5b6f00] flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.403 12.652a3 3 0 000-5.304 3 3 0 00-3.75-3.751 3 3 0 00-5.305 0 3 3 0 00-3.751 3.75 3 3 0 000 5.305 3 3 0 003.75 3.751 3 3 0 005.305 0 3 3 0 003.751-3.75zm-2.546-4.46a.75.75 0 00-1.214-.883l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd"></path></svg>
                </div>
                
                <p className="text-[12px] sm:text-[13px] font-medium text-gray-500 mb-3">
                  Travel Creator 
                </p>
                
                <div className="mt-auto pt-3 border-t border-gray-100 flex items-center justify-between">
                  <div className="flex items-center gap-1.5">
                    {/* <div className="flex -space-x-1.5">
                      <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64" alt="traveler" className="w-5 h-5 rounded-full border border-white" />
                      <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=64&h=64" alt="traveler" className="w-5 h-5 rounded-full border border-white" />
                    </div> */}
                    {/* <span className="text-[11px] font-medium text-gray-500">1.2K+ trips</span> */}
                  </div>
                  
                  <span className="text-[12px] font-bold text-[#1f2d1f] group-hover:text-[#5b6f00] transition-colors flex items-center gap-1">
                    Explore <span className="text-lg leading-none transform group-hover:translate-x-0.5 transition-transform">›</span>
                  </span>
                </div>
              </div>

            </div>
          ))}
        </div>
        {/* CTA BELOW GRID */}
<div className="mt-10 sm:mt-12 flex justify-center">
  <Link
    to="/creators"
    className="group inline-flex items-center justify-center gap-2 
               px-6 sm:px-7 py-3 
               bg-[#5b6f00] text-white 
               text-sm sm:text-base font-semibold 
               rounded-full 
               shadow-md hover:shadow-lg 
               hover:bg-[#4e6100] 
               active:scale-[0.97] 
               transition-all duration-300"
  >
    Explore All Creators
    <span className="text-lg leading-none transition-transform duration-300 group-hover:translate-x-1">
      →
    </span>
  </Link>
</div>

      </div>
      
    </section>
  );
}